export const Services = {
   "Get_QuickSearch": {
      "path": "https://rrapisearchengine.azurewebsites.net/",
      "method": "POST",
      "descrp": "method to list results of quick search"
   }
}